export type IconPathProps = {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
};

const icons = {
  menuLine: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M7 9h10" />
      <path d="M7 13h6" />
      <path d="M6 5h12a3 3 0 013 3v5a3 3 0 01-3 3H10l-4 3v-3H6a3 3 0 01-3-3V8a3 3 0 013-3z" />
    </svg>
  ),
  menuUsers: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M12 13a4 4 0 100-8 4 4 0 000 8z" />
      <path d="M4 20a8 8 0 0116 0" />
    </svg>
  ),
  menuSettings: ({
    color,
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  ),
  menuChat: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M5 7h10a3 3 0 013 3v4a3 3 0 01-3 3H9l-4 3v-3H5a3 3 0 01-3-3v-4a3 3 0 013-3z" />
      <path d="M13 7h1a3 3 0 013 3v2" />
    </svg>
  ),
  chevronsLeft: ({
    color,
    width = 20,
    height = 20,
    className,
  }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M12.5 5.5l-4 4 4 4" />
      <path d="M16.5 5.5l-4 4 4 4" />
    </svg>
  ),
  chevronsRight: ({
    color,
    width = 20,
    height = 20,
    className,
  }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M7.5 5.5l4 4-4 4" />
      <path d="M3.5 5.5l4 4-4 4" />
    </svg>
  ),
  signOut: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M12 3H6a3 3 0 00-3 3v12a3 3 0 003 3h6" />
      <path d="M16 17l5-5-5-5" />
      <path d="M9 12h11" />
    </svg>
  ),
  bell: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M6 9a6 6 0 0112 0c0 6 2 7 2 7H4s2-1 2-7" />
      <path d="M9 17a3 3 0 006 0" />
    </svg>
  ),
  chevronDown: ({
    color,
    width = 20,
    height = 20,
    className,
  }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M6 8l4 4 4-4" />
    </svg>
  ),
  chevronUp: ({ color, width = 20, height = 20, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M14 12l-4-4-4 4" />
    </svg>
  ),
  chevronLeft: ({
    color,
    width = 20,
    height = 20,
    className,
  }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M12 6l-4 4 4 4" />
    </svg>
  ),
  menuBars: ({
    color,
    width = 20,
    height = 20,
    className,
  }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
    >
      <path d="M3 5h14M3 10h14M3 15h14" />
    </svg>
  ),
  check: ({ color, width = 16, height = 16, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={2}
    >
      <path d="M4 10.5l3.5 3.5L16 6.5" />
    </svg>
  ),
  checkBold: ({ color, width = 12, height = 12, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 13l4 4L19 7" />
    </svg>
  ),
  searchInput: ({
    color,
    width = 20,
    height = 20,
    className,
  }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
        stroke={color ?? '#9CA3AF'}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sendMessage: ({
    color,
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      className={`w-6 h-6 rotate-90 ${className}`}
      fill={color ?? 'currentColor'}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
    >
      <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
    </svg>
  ),
  attach: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  ),
  emoji: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
      <line x1="9" y1="9" x2="9.01" y2="9" />
      <line x1="15" y1="9" x2="15.01" y2="9" />
    </svg>
  ),
  image: ({
    color = 'var(--color-neutral)',
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.27209 20.7279L10.8686 14.1314C11.2646 13.7354 11.4627 13.5373 11.691 13.4632C11.8918 13.3979 12.1082 13.3979 12.309 13.4632C12.5373 13.5373 12.7354 13.7354 13.1314 14.1314L19.6839 20.6839M14 15L16.8686 12.1314C17.2646 11.7354 17.4627 11.5373 17.691 11.4632C17.8918 11.3979 18.1082 11.3979 18.309 11.4632C18.5373 11.5373 18.7354 11.7354 19.1314 12.1314L22 15M10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9ZM6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sticker: ({
    color = 'var(--color-neutral)',
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.5 8V9.5M16.5 8V9.5M11 12.6001C11.8 12.6001 12.5 11.9001 12.5 11.1001V8M15.2002 15.2C13.4002 17 10.5002 17 8.7002 15.2M3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus: ({
    color = 'white',
    width = 20,
    height = 20,
    className,
  }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M9.99935 4.1665V15.8332M4.16602 9.99984H15.8327"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  close: ({
    color = 'var(--color-neutral)',
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendar: ({
    color = 'var(--color-neutral-400)',
    width = 22,
    height = 22,
    className,
  }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
    >
      <path
        d="M19.25 9.16634H2.75M14.6667 1.83301V5.49967M7.33333 1.83301V5.49967M7.15 20.1663H14.85C16.3901 20.1663 17.1602 20.1663 17.7485 19.8666C18.2659 19.603 18.6866 19.1823 18.9503 18.6648C19.25 18.0766 19.25 17.3065 19.25 15.7663V8.06634C19.25 6.5262 19.25 5.75612 18.9503 5.16787C18.6866 4.65042 18.2659 4.22972 17.7485 3.96607C17.1602 3.66634 16.3901 3.66634 14.85 3.66634H7.15C5.60986 3.66634 4.83978 3.66634 4.25153 3.96607C3.73408 4.22972 3.31338 4.65042 3.04973 5.16787C2.75 5.75612 2.75 6.5262 2.75 8.06634V15.7663C2.75 17.3065 2.75 18.0766 3.04973 18.6648C3.31338 19.1823 3.73408 19.603 4.25153 19.8666C4.83978 20.1663 5.60986 20.1663 7.15 20.1663Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  clock: ({
    color = 'var(--color-neutral-400)',
    width = 20,
    height = 20,
    className,
  }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M10.0003 5.00033V10.0003L13.3337 11.667M18.3337 10.0003C18.3337 14.6027 14.6027 18.3337 10.0003 18.3337C5.39795 18.3337 1.66699 14.6027 1.66699 10.0003C1.66699 5.39795 5.39795 1.66699 10.0003 1.66699C14.6027 1.66699 18.3337 5.39795 18.3337 10.0003Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  video: ({
    color = 'var(--color-neutral)',
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 8l6 4-6 4V8z" fill={color ?? 'currentColor'} />
    </svg>
  ),
  userProfile: ({
    color = 'white',
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <circle cx="12" cy="12" r="10" fill="#A8E6CF" />
      <circle cx="12" cy="9" r="3" fill={color} />
      <path d="M6 20c0-3.314 2.686-6 6-6s6 2.686 6 6" fill={color} />
    </svg>
  ),
  imageUrl: ({
    color = 'var(--color-neutral)',
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.27209 20.7279L10.8686 14.1314C11.2646 13.7354 11.4627 13.5373 11.691 13.4632C11.8918 13.3979 12.1082 13.3979 12.309 13.4632C12.5373 13.5373 12.7354 13.7354 13.1314 14.1314L19.6839 20.6839M14 15L16.8686 12.1314C17.2646 11.7354 17.4627 11.5373 17.691 11.4632C17.8918 11.3979 18.1082 11.3979 18.309 11.4632C18.5373 11.5373 18.7354 11.7354 19.1314 12.1314L22 15M10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9ZM6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 6L20 6M18 4L18 8"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  videoUrl: ({
    color = 'var(--color-neutral)',
    width = 24,
    height = 24,
    className,
  }: IconPathProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 8l6 4-6 4V8z" fill={color ?? 'currentColor'} />
      <path
        d="M16 6L20 6M18 4L18 8"
        stroke={color ?? 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  link: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  copy: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
  ),
  moreVertical: ({
    color,
    width = 16,
    height = 16,
    className,
  }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill={color ?? 'currentColor'}
    >
      <circle cx="12" cy="5" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <circle cx="12" cy="19" r="1.5" />
    </svg>
  ),
  megaphone: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 11v2a1 1 0 001 1h2l4 3V7L6 10H4a1 1 0 00-1 1z" />
      <path d="M14 8a4 4 0 010 8" />
      <path d="M17 5a8 8 0 010 14" />
      <path d="M7 17v2a1 1 0 001 1h1a1 1 0 001-1v-1" />
    </svg>
  ),
  aiStar: ({ color, width = 20, height = 20, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill={color ?? 'currentColor'}
    >
      <path d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
    </svg>
  ),
  help: ({ color, width = 24, height = 24, className }: IconPathProps) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke={color ?? 'currentColor'}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
    </svg>
  ),
} satisfies Record<string, (props: IconPathProps) => JSX.Element>;

export type IconName = keyof typeof icons;

export default icons;
